import classnames from 'classnames'
import styles from './PreviewButton.module.scss'
import { useContext, useEffect, useRef, useState } from 'react'
import { GlobalSettingsContext } from '@/context/GlobalSettings'

const PreviewButton = () => {
  const { isPreviewMode, hasSanityPreviewToken } = useContext(GlobalSettingsContext)
  const [closed, setClosed] = useState(false)
  const fetchingPreview = useRef(false)

  useEffect(() => {
    if (isPreviewMode || fetchingPreview.current || !hasSanityPreviewToken || process.env.NODE_ENV === 'development') {
      return
    }

    fetchingPreview.current = true

    const fire = async () => {
      try {
        await fetch('/api/enable-draft')

        // Create a URL object to properly handle parameters
        const url = new URL(window.location.href)

        // Check if preview parameter already exists
        if (!url.searchParams.has('preview')) {
          url.searchParams.set('preview', 'enabled')
          window.location.href = url.toString()
        }
      } catch (err) {
        console.error('[PreviewButton] Error enabling draft mode:', err)
      }
    }

    fire()
  }, [isPreviewMode, hasSanityPreviewToken])

  if (closed || !hasSanityPreviewToken || process.env.NODE_ENV === 'development') return null

  return (
    <div className={classnames(styles.PreviewButton, { [styles.isPreview]: isPreviewMode })}>
      <span className={styles.text}>
        Preview Mode <span className={styles.dot} />
      </span>

      <button
        className={styles.closeButton}
        onClick={() => {
          setClosed(true)
        }}
      >
        Close
      </button>
    </div>
  )
}

PreviewButton.displayName = 'PreviewButton'

export default PreviewButton
